export default {
  'formandstep-form.basic.title': '基礎表單',
  'formandstep-form.basic.description':
    '表單頁用於向用戶收集或驗證信息，基礎表單常見於數據項較少的表單場景。',

  'formandstep-form.email.required': '請輸入郵箱地址！',
  'formandstep-form.email.wrong-format': '郵箱地址格式錯誤！',
  'formandstep-form.userName.required': '請輸入賬戶!',
  'formandstep-form.password.required': '請輸入密碼！',
  'formandstep-form.password.twice': '兩次輸入的密碼不匹配!',
  'formandstep-form.strength.msg': '請至少輸入 6 個字符。請不要使用容易被猜到的密碼。',
  'formandstep-form.strength.strong': '強度：強',
  'formandstep-form.strength.medium': '強度：中',
  'formandstep-form.strength.short': '強度：太短',
  'formandstep-form.confirm-password.required': '請確認密碼！',
  'formandstep-form.phone-number.required': '請輸入手機號！',
  'formandstep-form.phone-number.wrong-format': '手機號格式錯誤！',
  'formandstep-form.verification-code.required': '請輸入驗證碼！',
  'formandstep-form.title.required': '請輸入標題',
  'formandstep-form.date.required': '請選擇起止日期',
  'formandstep-form.goal.required': '請輸入目標描述',
  'formandstep-form.standard.required': '請輸入衡量標淮',

  'formandstep-form.form.get-captcha': '獲取驗證碼',
  'formandstep-form.captcha.second': '秒',
  'formandstep-form.form.optional': '（選填）',
  'formandstep-form.form.submit': '提交',
  'formandstep-form.form.save': '保存',
  'formandstep-form.email.placeholder': '郵箱',
  'formandstep-form.password.placeholder': '至少6位密碼，區分大小寫',
  'formandstep-form.confirm-password.placeholder': '確認密碼',
  'formandstep-form.phone-number.placeholder': '手機號',
  'formandstep-form.verification-code.placeholder': '驗證碼',
  'formandstep-form.title.label': '標題',
  'formandstep-form.title.placeholder': '給目標起個名字',
  'formandstep-form.date.label': '起止日期',
  'formandstep-form.placeholder.start': '開始日期',
  'formandstep-form.placeholder.end': '結束日期',
  'formandstep-form.goal.label': '目標描述',
  'formandstep-form.goal.placeholder': '請輸入妳的階段性工作目標',
  'formandstep-form.standard.label': '衡量標淮',
  'formandstep-form.standard.placeholder': '請輸入衡量標淮',
  'formandstep-form.client.label': '客戶',
  'formandstep-form.label.tooltip': '目標的服務對象',
  'formandstep-form.client.placeholder': '請描述妳服務的客戶，內部客戶直接 @姓名／工號',
  'formandstep-form.invites.label': '邀評人',
  'formandstep-form.invites.placeholder': '請直接 @姓名／工號，最多可邀請 5 人',
  'formandstep-form.weight.label': '權重',
  'formandstep-form.weight.placeholder': '請輸入',
  'formandstep-form.public.label': '目標公開',
  'formandstep-form.label.help': '客戶、邀評人默認被分享',
  'formandstep-form.radio.public': '公開',
  'formandstep-form.radio.partially-public': '部分公開',
  'formandstep-form.radio.private': '不公開',
  'formandstep-form.publicUsers.placeholder': '公開給',
  'formandstep-form.option.A': '同事甲',
  'formandstep-form.option.B': '同事乙',
  'formandstep-form.option.C': '同事丙',
};
